import { NgModule } from '@angular/core';
import { ProfileComponent } from './profile.component';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { ProfileOutputModule } from './profile-output/profile-output.module';
import { ProfileOverviewComponent } from './profile-overview/profile-overview.component';

import { TagsModule } from '../parts/tags/tags.module';
import { ExpandableTextModule } from '../parts/expandable-text/expandable-text.module';
import { ContentBoxModule } from '../parts/content-box/content-box.module';
import { BriefsModule } from '../parts/briefs/briefs.module';
import { CitationsModule } from '../parts/citations/citations.module';

import { ProfileOverviewAffiliationDisplayComponent } from './profile-overview/profile-overview-affiliation-display/profile-overview-affiliation-display.component';
import { ProfileHighlightsComponent } from './profile-highlights/profile-highlights.component';
import {
    AvatarComponent,
    ExpandableComponent,
    FloatingToolbarButtonsComponent,
    FloatingToolbarComponent,
    FloatingToolbarSeparatorComponent,
    HtmlSanitizePipe,
    LoadingSlateComponent,
    OrcidConnectComponent,
    OrcidLinkComponent,
    OrcidLogoComponent,
    PagingComponent,
    PrologueComponent,
    SeparatorComponent,
    StatusTagComponent,
    StickyDirective,
    UrlTrustPipe,
} from '@exl-ng/mulo-common';
import {
    BriefComponent,
    CenteredBlockLayoutComponent,
    NavMainLayoutComponent,
    SideMainLayoutComponent,
} from '@exl-ng/mulo-views';
import { NgxPaginationModule } from 'ngx-pagination';

import { ProfileAwardsComponent } from './profile-awards/profile-awards.component';
import { ButtonSplashComponent } from '../bits/button-splash/button-splash.component';
import { ProfileHighlightsAwardsComponent } from './profile-highlights-awards/profile-highlights-awards.component';
import { ProfileMentionsComponent } from './profile-mentions/profile-mentions.component';
import { ClaimOutputsComponent } from './claim-outputs/claim-outputs.component';
import { CvModule } from './cv/cv.module';
import { MatIconModule } from '@angular/material/icon';
import { ContentLoaderModule } from '@ngneat/content-loader';

@NgModule({
    imports: [
    SharedModule,
    RouterModule,
    ProfileOutputModule,
    AvatarComponent,
    TagsModule,
    ExpandableTextModule,
    ContentBoxModule,
    BriefsModule,
    CitationsModule,
    OrcidLinkComponent,
    OrcidLogoComponent,
    OrcidConnectComponent,
    SideMainLayoutComponent,
    NavMainLayoutComponent,
    CenteredBlockLayoutComponent,
    StatusTagComponent,
    ButtonSplashComponent,
    PrologueComponent,
    StickyDirective,
    FloatingToolbarComponent,
    FloatingToolbarButtonsComponent,
    FloatingToolbarSeparatorComponent,
    PagingComponent,
    ExpandableComponent,
    BriefComponent,
    NgxPaginationModule,
    LoadingSlateComponent,
    UrlTrustPipe,
    CvModule,
    HtmlSanitizePipe,
    SeparatorComponent,
    MatIconModule,
    ContentLoaderModule,
    MatIconModule,
    ProfileComponent,
    ProfileOverviewComponent,
    ProfileOverviewAffiliationDisplayComponent,
    ProfileHighlightsComponent,
    ProfileAwardsComponent,
    ProfileHighlightsAwardsComponent,
    ProfileMentionsComponent,
    ClaimOutputsComponent,
],
    exports: [ProfileComponent, CvModule],
})
export class ProfileModule {}
